import { useCallback } from 'react'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { Installation } from 'src/Libs/installations/models'
import { AccountLinkModel } from '../models'
import { isAccountAllowedToGetApiAccess } from '../utils'

interface APIAccessReturnType {
  isApiAccessFeatureEnabled: boolean
  isUserLevelAllowedToGetApiAccess: (item: AccountLinkModel) => boolean
}

/**
 * Helper to check if API Access is enabled by feature-flag and per item
 * @param installation installation to check for the owner status
 * @returns
 */
export const useAPIAccessChecker = (installation: Installation): APIAccessReturnType => {
  const {
    featureFlags: { apiAccessGroups },
    isFeatureFlagsLoading,
  } = useFeatureFlagsContext()

  /** The ApiAccessGroups are undefined  */
  const isApiAccessFeatureEnabled = !isFeatureFlagsLoading && !!apiAccessGroups

  const isUserLevelAllowedToGetApiAccess = useCallback(
    (item: AccountLinkModel): boolean => isApiAccessFeatureEnabled && isAccountAllowedToGetApiAccess(item, installation, apiAccessGroups),
    [apiAccessGroups, installation, isApiAccessFeatureEnabled]
  )

  return { isApiAccessFeatureEnabled, isUserLevelAllowedToGetApiAccess }
}
